import dayjs from "dayjs";

/**
 * Spring's LocalDate can arrive as either "YYYY-MM-DD" or [year, month, day].
 * The API contract always sends dates back as YYYY-MM-DD query/body values.
 */
export const toIsoDate = (value) => {
  if (!value) return undefined;
  if (Array.isArray(value) && value.length >= 3) {
    const [year, month, day] = value;
    return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
  }
  if (dayjs.isDayjs(value)) return value.format("YYYY-MM-DD");
  if (typeof value === "string") return value.slice(0, 10);
  return dayjs(value).format("YYYY-MM-DD");
};

export const toPeriodRange = (range = {}) => ({
  startDate: toIsoDate(range.startDate),
  endDate: toIsoDate(range.endDate),
});
